// Thin fetch helpers for /api/services (auth model = user_id in the query
// string on GET/DELETE and in the JSON body on POST/PUT/PATCH, Section 4).

const API_URL = process.env.REACT_APP_BACKEND_URL;

export class ServicesApiError extends Error {
  constructor(status, detail) {
    super(detail || `Request failed (${status})`);
    this.status = status;
    this.detail = detail;
  }
}

async function handle(res) {
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const detail = typeof data?.detail === 'string' ? data.detail : null;
    throw new ServicesApiError(res.status, detail);
  }
  return data;
}

function qs(params) {
  const u = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') u.set(k, String(v));
  });
  const s = u.toString();
  return s ? `?${s}` : '';
}

export const svcGet = (path, userId, params = {}) =>
  fetch(`${API_URL}/api/services${path}${qs({ user_id: userId, ...params })}`).then(handle);

export const svcDelete = (path, userId, params = {}) =>
  fetch(`${API_URL}/api/services${path}${qs({ user_id: userId, ...params })}`, { method: 'DELETE' }).then(handle);

const withBody = (method) => (path, userId, body = {}) =>
  fetch(`${API_URL}/api/services${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, ...body }),
  }).then(handle);

export const svcPost = withBody('POST');
export const svcPut = withBody('PUT');
export const svcPatch = withBody('PATCH');

// Public token page: no user_id, no login (Section 4.12).
export const publicGet = (token) =>
  fetch(`${API_URL}/api/services/public/respond/${encodeURIComponent(token)}`).then(handle);
export const publicPost = (token, body) =>
  fetch(`${API_URL}/api/services/public/respond/${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then(handle);

export const errorText = (err, fallback = 'Something went wrong. Please try again.') =>
  (err && err.detail) || fallback;
